module.exports = __webpack_public_path__ + "img/1 (130).b7c03d51.png";